import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'insuranceLimits',
  standalone: false
})
export class InsuranceLimitsPipe implements PipeTransform {
  transform(value: number, type: 'PERCENTAGE' | 'AMOUNT'): string {
    if (isNaN(value)) return '';

    switch (type) {
      case 'PERCENTAGE':
        return `${value}%`;
      case 'AMOUNT':
        return `MZN ${value.toFixed(2)}`;
      default:
        return value.toString();
    }
  }

}
